import MiniGameScene from "./MiniGameScene";
//assets
import PasswordAtlasTexture from "../../../assets/atlas/randomiserGame.png";
import PasswordAtlasData from "../../../assets/atlas/randomiserGame.json";

import ImageButton from "../../components/ImageButton";
import WordOptionComponent from "../../components/ncsc/WordOptionComponent";
import {
  RandomiserDataModel,
  RandomItem,
  RandomItemQuestion,
} from "../../interfaces/IContentModel";
import PasswordStrengthDisplay from "../../components/ncsc/PasswordStrengthDisplay";
import { PHShape } from "../../plugins/global/PlaceholderPlugin";
import { shuffleArrayFY } from "../../plugins/utils/Utils";

export default class PasswordRandomiserScene extends MiniGameScene {
  private submitButton: ImageButton;
  private model: RandomiserDataModel;
  private currentQuestion: RandomItemQuestion;
  private optionArray: WordOptionComponent[];
  private passwordStrength: number = 0;
  private catHex: number[];
  private uniqueItems: number[];
  private duplicateItems: number[];
  private sameText: Phaser.GameObjects.Text;

  constructor() {
    super({
      key: "PasswordRandomiserScene",
      active: false,
    });
    console.log("PasswordRandomiserScene::constructor");
  }

  preload(): void {
    //
    super.preload();
    // this.cameras.main.setBackgroundColor(0x2b2a7d);
    this.sponge.placeholder.image(
      this,
      this.cameras.main.centerX,
      this.cameras.main.centerY + 80,
      PHShape.RECT,
      {
        width: this.cameras.main.width,
        height: this.cameras.main.height - 160,
        radius: 0,
      },
      0x2b2a7d
    );

    this.cameras.main.setBackgroundColor(0x2b2a7d);

    this.load.atlas("password-atlas", PasswordAtlasTexture, PasswordAtlasData);
    this.model = this.sponge.data.model.content.randomiserDataModel;
  }

  create(): void {
    super.create();
    console.log("PasswordRandomiserScene::create");
    this.add
      .image(360, 220, "password-atlas", "randomiser-text.png")
      .setOrigin(0.5, 0)
      .setScale(1);

    // set question from shuffled easy array first then move to hard after 3 completed
    this.createWordArrays();

    this.catHex = []; //8 categories
    this.uniqueItems = [];

    this.sameText = this.add
      .text(360, 1140, "", this.sponge.data.model.fonts.answer)
      .setOrigin(0.5)
      .setWordWrapWidth(560)
      .setFill("#ff00ff");

    this.submitButton = new ImageButton(
      this,
      360,
      1140,
      this.sponge.data.model.content.strings.submit,
      () => {
        this.submitWords();
      },
      "submitButton"
    );

    //this.sponge.startVO("password-intro", this);

    // const meter = new PasswordStrengthDisplay(this, 2);
  }

  createWordArrays() {
    //shuffle all possible options first
    const qArray: RandomItem[] = shuffleArrayFY(this.model.questionItems);
    this.optionArray = [];
    //iterate through to create 3 RandomItemQuestions
    for (let i = 0; i < 3; i++) {
      const qOptions: RandomItem[] = [];
      for (let j: number = 0; j < 3; j++) {
        //remove first choice from selection of all items
        const randomPick = qArray[j + i * 3];
        qOptions.push({ category: randomPick.category, text: randomPick.text });
      }

      //now create our components using filtered choices
      const wordOption = new WordOptionComponent(
        this,
        this.cameras.main.centerX,
        560 + 200 * i,
        qOptions
      );
      this.optionArray.push(wordOption);
    }
  }

  submitWords() {
    //
    this.passwordStrength = this.checkCategories();
    console.log("passwordStrength:", this.passwordStrength);
    const meter = new PasswordStrengthDisplay(this, this.passwordStrength);
    meter.on("meterCompleted", this.showSimilarItems, this);

    this.submitButton.setActive(false).setVisible(false).disableInteractive();
  }

  showSimilarItems() {
    if (this.passwordStrength < 3) {
      for (let i = 0; i < this.optionArray.length; i++) {
        if (this.optionArray[i].currentCategory === this.duplicateItems[0])
          this.optionArray[i].showOverlay();
      }

      this.sameText.setText(
        this.sponge.data.model.content.strings.unluckyRandom
      );
      this.time.addEvent({
        delay: 5000,
        callbackScope: this,
        callback: this.showFeedback,
      });
    } else {
      this.showFeedback();
    }
  }

  showFeedback() {
    switch (this.passwordStrength) {
      case 3:
        // show Positive feedback from model
        this.complete(1);
        this.shutdown();
        break;
      default:
        // show Negative feedback from model
        this.complete(0);
        this.shutdown();
        break;
    }
  }

  checkCategories(): number {
    const categoryTypes: number[] = [];
    for (let i = 0; i < this.optionArray.length; i++) {
      categoryTypes.push(this.optionArray[i].currentCategory);
      console.log(
        "OPTION: ",
        this.optionArray[i].currentCategory,
        this.optionArray[i].currentWord
      );
    }
    console.log("CATS CHOSEN: ", categoryTypes);

    //find duplicates
    const sortArr: number[] = categoryTypes.sort();
    this.duplicateItems = [];
    for (let i = 0; i < categoryTypes.length; i++) {
      if (sortArr[i + 1] == sortArr[i]) {
        this.duplicateItems.push(sortArr[i]);
      }
    }
    console.log(this.duplicateItems);

    //find unique items
    this.uniqueItems = categoryTypes.filter((x, i, a) => a.indexOf(x) == i);

    console.log("UNIQUE CATS FOUND: ", this.uniqueItems);
    //to win length of array should be 3 - as all are unique
    return this.uniqueItems.length;
  }

  update(time: number, delta: number): void {
    //
  }

  shutdown(): void {
    //call our minigame complete method
    super.shutdown();
  }
}
